import { Card, CardBody, Col } from "reactstrap";
import CommonHeader from "../../../../Common/CommonHeader";
import { PaginationSizing } from "../../../../utils/Constant";
import LargePage from "./LargePage";
import MediumPage from "./MediumPage/MediumPage";
import SmallPage from "./SmallPage/SmallPage";

const PaginationSize = () => {
  const subMenu = [
    {
      text: "Use ",
      code: "[pagination-lg/pagination-md/pagination-lg]",
    },
    {
      text: " for additional sizes.",
    },
  ];
  return (
    <Col xxl={6}>
      <Card>
        <CommonHeader title={PaginationSizing} subTitle={subMenu} headClass="pb-0" />
        <CardBody>
          <LargePage />
          <MediumPage />
          <SmallPage />
        </CardBody>
      </Card>
    </Col>
  );
};

export default PaginationSize;
